(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zani-gift-selections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zani-gift-selection')) {
    customElements.define('zani-gift-selection', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        this.form = this.querySelector('form');
        this.button = this.form.querySelector('button');
        this.error = this.form.querySelector('[role="alert"]');
        this.button.hidden = false;
        this.form.querySelector('.zani-gifts__fallback').hidden = true;
        this.form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (this.button.disabled) return;
          const originalLabel = this.button.textContent;
          this.button.disabled = true;
          this.button.textContent = this.form.dataset.adding;
          this.form.setAttribute('aria-busy', 'true');
          this.error.hidden = true;
          try {
            const fields = new FormData(this.form);
            const items = [...this.form.querySelectorAll('input[name$="[id]"]')].map((input) => ({
              id: Number(input.value),
              quantity: Number(fields.get(input.name.replace('[id]', '[quantity]')))
            }));
            const response = await fetch(this.form.dataset.addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart add failed');
            window.location.assign(this.form.dataset.cartUrl);
          } catch {
            this.error.textContent = this.form.dataset.error;
            this.error.hidden = false;
            this.button.disabled = false;
            this.button.textContent = originalLabel;
            this.form.removeAttribute('aria-busy');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zani-home-autumn-promo"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zani-home-autumn-promo')) {
  class ZaniHomeAutumnPromo extends HTMLElement {
    connectedCallback() {
      this.refresh();
      this.promoTimer = setInterval(() => this.refresh(), 60000);
    }
    disconnectedCallback() {
      clearInterval(this.promoTimer);
    }
    refresh() {
      const end = Date.parse(this.dataset.endIso || '');
      const isEditor = this.dataset.editor === 'true';
      this.hidden = !(isEditor || (Number.isFinite(end) && Date.now() < end));
    }
  }
  customElements.define('zani-home-autumn-promo', ZaniHomeAutumnPromo);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zani-product-stack"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function getStep(carousel) {
      var first = carousel.querySelector('*');
      if (!first) return carousel.clientWidth;
      var rect = first.getBoundingClientRect();
      var style = getComputedStyle(carousel);
      var gap = parseFloat(style.columnGap || style.gap || '16') || 16;
      return rect.width + gap;
    }

    function updateArrows(wrapper) {
      var carousel = wrapper.querySelector('[data-zani-carousel]');
      if (!carousel) return;
      var prev = wrapper.querySelector('.zani-stack__nav--prev');
      var next = wrapper.querySelector('.zani-stack__nav--next');
      var atStart = carousel.scrollLeft <= 1;
      var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 1;
      if (prev) prev.hidden = atStart;
      if (next) next.hidden = atEnd;
    }

    function init() {
      document.querySelectorAll('.zani-stack__carousel-wrapper').forEach(function(wrapper) {
        var carousel = wrapper.querySelector('[data-zani-carousel]');
        if (!carousel || carousel.dataset.zaniInit) return;
        carousel.dataset.zaniInit = '1';

        wrapper.addEventListener('click', function(e) {
          var btn = e.target.closest('.zani-stack__nav');
          if (!btn || !wrapper.contains(btn)) return;
          var step = getStep(carousel);
          var dir = btn.dataset.direction === 'next' ? 1 : -1;
          carousel.scrollBy({ left: dir * step, behavior: 'smooth' });
        });

        carousel.addEventListener('scroll', function() { updateArrows(wrapper); }, { passive: true });
        window.addEventListener('resize', function() { updateArrows(wrapper); }, { passive: true });

        updateArrows(wrapper);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zani-promotions"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zani-promotion-calendar')){
  class ZaniPromotionCalendar extends HTMLElement{
    connectedCallback(){this.refresh();this.timer=setInterval(()=>this.refresh(),60000)}
    disconnectedCallback(){clearInterval(this.timer)}
    refresh(){
      const now=Date.now();
      const editor=this.dataset.editor==='true';
      const container=this.querySelector('[data-campaign-container]');
      let active=0;
      this.querySelectorAll('[data-campaign]').forEach(card=>{
        const starts=Date.parse(card.dataset.startIso||'');
        const ends=Date.parse(card.dataset.endIso||'');
        const valid=Number.isFinite(starts)&&Number.isFinite(ends)&&ends>starts;
        const visible=valid&&(editor||(now>=starts&&now<ends));
        card.hidden=!visible;
        if(visible) active++;
      });
      if(container) container.hidden=active===0;
    }
  }
  customElements.define('zani-promotion-calendar',ZaniPromotionCalendar);
}

  } catch(e) { console.error(e); }
})();
})();
